import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Alert,
  CircleQuestion
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class ExtendDemoQuestion extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){

    }

    render(){

        return(
            <Main flex="grow" fill="vertical" overflow="auto">            
            <Layer animate modal={false}>
              <Box align="center" justify="center">
                <Box align="center" justify="center" background={{"color":"brand"}} fill="horizontal">
                  <Box align="center" justify="between" direction="row" gap="medium" fill="horizontal">
                    <CircleQuestion size="large" color="white" />
                    <Heading size="small" level="1" margin="small">
                      Extend your demo ?
                    </Heading>
                  </Box>
                </Box>
                <Box align="center" justify="center">
                  <Heading size="small" level="4" margin="small">
                    Please confirm you want to extend this demo by 2 hours ?
                  </Heading>
                </Box>
                <Box align="center" justify="center" direction="row" gap="large" margin="medium">
                  <Button label="Yes" active={false} primary reverse type="button" onClick={this.props.yes} />
                  <Button label="No" active={false} primary={false} reverse type="button" secondary onClick={this.props.no}/>
                </Box>
              </Box>
            </Layer>
          </Main>
        )
    }
}

export default ExtendDemoQuestion;